import React from "react";

/**
 * Escala Fibonacci con la que desarrollo califica cada reporte en Jira
 * ("Story Point Real")
 *
 */
export const ESCALA_FIBONACCI = [
  { puntos: 1, titulo: "Trivial", detalle: "Un texto, un dato mal puesto. Sin riesgo." },
  { puntos: 2, titulo: "Muy sencillo", detalle: "Ajuste puntual en una sola pantalla." },
  { puntos: 3, titulo: "Sencillo", detalle: "Se sabe qué tocar y no afecta a nada más." },
  { puntos: 5, titulo: "Medio", detalle: "Toca varias partes o hay que probarlo a fondo." },
  { puntos: 8, titulo: "Complejo", detalle: "Varios módulos o reglas de negocio delicadas." },
  { puntos: 13, titulo: "Muy complejo", detalle: "Hay que investigar antes de resolver." },
  { puntos: 21, titulo: "Mayor", detalle: "Casi un desarrollo nuevo; se suele partir en varios." },
];

/**
 * Nivel exacto de un puntaje
 */
export const nivelDePuntos = (puntos) =>
  typeof puntos === "number" ? ESCALA_FIBONACCI.find((n) => n.puntos === puntos) || null : null;

export const tienePuntos = (ticket) => typeof ticket?.storyPoints === "number";

export const AyudaEscalaPuntos = () => (
  <div style={{ fontSize: 12, lineHeight: 1.5 }}>
    <div style={{ fontWeight: 700, marginBottom: 6 }}>Escala de complejidad (Fibonacci, 1 a 21)</div>
    <div style={{ marginBottom: 8, color: "#d9d9d9" }}>
      No mide tiempo, mide qué tan complejo e incierto fue resolver el reporte. Un 8 no tarda cuatro veces
      lo que un 2: es cuatro veces más difícil de anticipar.
    </div>
    {ESCALA_FIBONACCI.map((n) => (
      <div key={n.puntos} style={{ display: "flex", gap: 8, marginBottom: 3 }}>
        <span style={{ flex: "0 0 22px", textAlign: "right", fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>
          {n.puntos}
        </span>
        <span>
          <b>{n.titulo}</b> — {n.detalle}
        </span>
      </div>
    ))}
  </div>
);
